/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable no-restricted-properties */
/* eslint-disable prefer-template */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from 'react-router-dom';
import {
  validateEmail,
  emailHasSpecialCharacter,
  hasNumber,
  hasSpecialCharacterWhitespaceAllowed,
} from '../../utils/regex';

import './landing-component.scss';

declare global {
  interface Window {
    grecaptcha: any
  }
}

type LandingComponentTypes = {
  headline?: string
  text?: string
} & typeof defaultProps;
const defaultProps = {
  headline: '',
  text: '',
};

const LandingComponent = (props: LandingComponentTypes) => {
  const { headline, text } = props;
  const history = useHistory();

  const [artistNameInput, setArtistNameInput] = useState('');
  const [emailInput, setEmailInput] = useState('');
  const [socialInput, setSocialInput] = useState('');
  const [showTermsAndConditionsPopup, setShowTermsAndConditionsPopup] = useState(false);
  const [agreeToTermsAndConditions, setAgreeToTermsAndConditions] = useState(false);

  const [artistNameInvalid, setArtistNameInvalid] = useState(2);
  const [emailInvalid, setEmailInvalid] = useState(2);
  const [socialInvalid, setSocialInvalid] = useState(2);
  const [termsAndConditionsInvalid, setTermsAndConditionsInvalid] = useState(2);

  const [fileSelected, setFileSelected] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);
  const [fileUploadProgress, setFileUploadProgress] = useState(0);
  const [fileUploadingSuccess, setFileUploadingSuccess] = useState(false);
  const [assetUploadFailed, setAssetUploadFailed] = useState(false);

  const [assetFile, setAssetFile] = useState<any>();
  const [uploadAssetFileSize, setUploadAssetFileSize] = useState(0);
  const [uploadAssetFileType, setUploadAssetFileType] = useState('');
  const [uploadAssetOriginalFileName, setUploadAssetOriginalFileName] = useState('');
  const [submitWasClicked, setSubmitWasClicked] = useState(false);

  const onSelectFile = (event: any) => {
    const fileSizeRaw = event.target.files[0].size;
    const file = event.target.files[0];

    setAssetFile(file);
    setUploadAssetFileSize(fileSizeRaw);
    setUploadAssetFileType(file.type);
    setUploadAssetOriginalFileName(file.name);
    setFileSelected(true);
  };

  const updateSocialInput = (e: any) => {
    e.preventDefault();
    let input = e.target.value;
    input = input.trim();
    if (input.length > 350) return;
    setSocialInput(input);
  };

  const updateEmailInput = async (e: any) => {
    e.preventDefault();
    let input = e.target.value;
    input = input.trim();
    input = input.toLowerCase();
    if (input.length > 50) return;
    setEmailInput(input);
  };

  const updateArtistNameInput = (e: any) => {
    e.preventDefault();
    const input = e.target.value;
    if (input.length > 50) return;
    setArtistNameInput(input);
  };

  const toggleTerms = () => {
    setAgreeToTermsAndConditions(!agreeToTermsAndConditions);
  };

  const toggleTermsAndConditionsPopup = () => {
    setShowTermsAndConditionsPopup(!showTermsAndConditionsPopup);
  };

  const onClickOkSuccess = () => {
    setFileUploading(false);
    setFileUploadProgress(0);
    setArtistNameInput('');
    setEmailInput('');
    setSocialInput('');
    setAgreeToTermsAndConditions(false);
    setAssetFile(null);
    setUploadAssetFileSize(0);
    setUploadAssetFileType('');
    setUploadAssetOriginalFileName('');
    setSubmitWasClicked(false);
  };

  const handleVerifyReCAPTCHA = async () => new Promise((resolve) => {
    try {
      const { grecaptcha } = window;
      grecaptcha.ready(() => {
        grecaptcha.execute('6Lc1hcQdAAAAAG716YlA9aO2Xw8PgebydJAOtlVR', { action: 'submit' }).then((token: string) => {
          resolve(token);
        });
      });
    } catch (err) {
      console.log(err);
    }
  });

  const onClickSubmit = async () => {
    const { grecaptcha } = window;
    if (!grecaptcha) return;

    let recaptchaToken;
    try {
      recaptchaToken = await handleVerifyReCAPTCHA();
    } catch (err) {
      console.log(err);
    }

    setSubmitWasClicked(true);

    const isValidEmail = await validateEmail(emailInput);
    const artistNameHasSpecial = await hasSpecialCharacterWhitespaceAllowed(artistNameInput);
    const artistNameHasNumber = await hasNumber(artistNameInput);

    let isArtistNameValid = true;
    let isSocialValid = true;
    let isTermsAndConditionsValid = true;

    if (artistNameHasSpecial || artistNameHasNumber || artistNameInput.length === 0) {
      isArtistNameValid = false;
      setArtistNameInvalid(1);
    } else {
      setArtistNameInvalid(0);
    }

    if (!isValidEmail) {
      setEmailInvalid(1);
    } else {
      setEmailInvalid(0);
    }

    if (socialInput.length === 0) {
      isSocialValid = false;
      setSocialInvalid(1);
    } else {
      setSocialInvalid(0);
    }

    if (!agreeToTermsAndConditions) {
      isTermsAndConditionsValid = false;
      setTermsAndConditionsInvalid(1);
    } else {
      setTermsAndConditionsInvalid(0);
    }

    if (
      !isArtistNameValid
      || !isSocialValid
      || !isTermsAndConditionsValid
      || !isValidEmail
    ) {
      toast.error('Please correct the errors and try again.');
      return;
    }

    const submissionData = {
      artistNameInput,
      emailInput,
      socialInput,
      agreeToTermsAndConditions,
      contentType: uploadAssetFileType,
      originalFileName: uploadAssetOriginalFileName,
      recaptchaToken,
    };

    const signedUrl = await logUserUpload(submissionData);

    if (typeof signedUrl !== 'string') {
      toast.error('There was an error submitting your artwork, please try again later.');
      return;
    }

    uploadFile(signedUrl);
  };

  const logUserUpload = (submissionData: object) => new Promise((resolve) => {
    setFileUploadingSuccess(false);
    setFileUploading(true);
    Axios.post(
      'https://4b1dpmmxnc.execute-api.ap-southeast-2.amazonaws.com/dev/submission',
      submissionData,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    ).then(async (response: any) => {
      const signedURL = response.data.data.uploadUrl.uploadURL;
      resolve(signedURL);
    }).catch((error) => {
      toast.error('There was an error submitting your artwork, please try again later.');
      setFileUploading(false);
      resolve(error);
    });
  });

  const uploadFile = async (signedUrl: string) => {
    Axios.put(
      signedUrl,
      assetFile,
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'image/' + uploadAssetFileType.split('/')[1],
        },
        onUploadProgress(progressEvent) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setFileUploadProgress(percentCompleted);
        },
      },
    ).then(async (response) => {
      if (response.status !== 200) {
        setFileUploading(false);
        toast.error('There was an error submitting your artwork, please try again later.');
      } else {
        toast.success('Your artwork was submitted!');
        setFileUploadingSuccess(true);
      }
    }).catch((error) => {
      setFileUploading(false);
      toast.error('There was an error submitting your artwork, please try again later.');
    });
  };

  return (
    <div className="landing-component">
      <ToastContainer
        position="top-left"
      />

      {showTermsAndConditionsPopup ? (
        <div className="popup terms-and-confitions">
          <div className="popup-content">
            <h3>TERMS &amp; CONDITIONS</h3>
            <br />
            <span>
              <b>1. How many ball designs can I submit?</b>
              <br />
              All artists are allowed to submit one single design.
              <br />
              <br />

              <b>2. I submitted a design but haven't heard back, what's taking so long?</b>
              <br />
              Thanks for your patience! We've received a high volume of artist submissions that we are working around the clock
              to review.
              <br />
              <br />

              <b>3. The submission link to upload my artwork isn't working, who can I contact?</b>
              <br />
              Join the Discord and get in touch with us, we're always here to help: https://discord.gg/GuGJgpzGXV
              <br />
              <br />

              <b>4. What recognition do I get as the artist?</b>
              <br />
              Your name will appear in the NFT metadata in inscribed into the blockchain and live on in perpetuity.
              <br />
              <br />

              <b>5. Can I submit someone else's artwork, even if I've purchased it?</b>
              <br />
              No, you may only submit an artwork if you are the creator.
              <br />
              <br />

              <b>6. Can I submit a NFT that I own as ball artwork?</b>
              <br />
              We are working with select NFT communities and only holders of NFT's from these communities will be able to submit their NFT as artwork.
              <br />
              <br />

              <b>7. Who is approving the designs?</b>
              <br />
              We have a design committee who review every submission to ensure compliance with standards, terms and conditions.
              <br />
              <br />

              <b>8. How will I know if my design has been approved?</b>
              <br />
              If your design is approved, you will be notified via the email you entered on the submission form.
              <br />
              <br />

              <b>9. How much and when do I get paid?</b>
              <br />
              Artists whose submissions have been accepted will receive the higher of $500AUD or 0.025% of the projects gross revenue. Payment will be made no later than 14 days after public sale ends.
              <br />
              <br />

              <b>10. I don't have a digital wallet, so how will I get paid?</b>
              <br />
              We will be able to provide payment via bank transfer. Please send enquiries to accounts@artballs.io
              <br />
              <br />

              <b>11. Can I mint my own ball design?</b>
              <br />
              Every artist AO Art Ball will be placed into the randomised pool so w e can't promise that you will receive your ball design when minting. It's possible, although the odds are 1:6,776 that you will mint your own AO ball design.
              <br />
              <br />

              <b>12. Do I know who receives my art ball?</b>
              <br />
              AO Art Ball NFTs will be randomly distributed at the time of minting. Once all of the NFTs have been minted, you'll be able to use OpenSea's search functions to find your ball and it's current owner.
              <br />
              <br />

              <b>13. Do I get a percentage of the secondary sale commissions?</b>
              <br />
              Artists won't receive secondary sales commissions, but will be compensated for their artwork submission with $500AUD or 0.025% of the gross sales (whichever is higher!)
              <br />
              <br />

              <b>14. Do I need to be a professional artist to submit an artwork?</b>
              <br />
              No! We welcome artists at every stage of their artistic journey - from professional artist to anyone who likes to dabble in art. This is a community project for all.
              <br />
              <br />

              <b>15. What intellectual property rights do I retain from submitting my artwork?</b>
              <br />
              You as the artist retain the rights on the art work, but not of the AO ball that is created from it.
              <br />
              <br />

              <b>16. Can I withdraw my submission if I change my mind?</b>
              <br />
              You will receive an email confirming your submission has been accepted and at this point you have the option to proceed or not.
              <br />
              <br />

              <b>17. When do I need to submit my design by?</b>
              <br />
              Submission closes at 11.59pm AEDST on 10th January 2022.
              <br />
              <br />

              <b>18. What will be my NFT be called?</b>
              <br />
              The artist name that you provided on the submission form will be the title of your NFT.
              <br />
              <br />

              <b>19. Can I be paid in cryptocurrency?</b>
              <br />
              Yes. It will be be in Ethereum. There will be a confirmation email post-sale that will detail the process to receive payment.
              <br />
              <br />
            </span>
            <div
              className="submit ok-button"
              onClick={() => toggleTermsAndConditionsPopup()}
            />
          </div>
          <div className="popup-background" />
        </div>
      ) : (<></>)}

      {fileUploading ? (
        <div className="popup">
          <div className="popup-content">
            {fileUploadProgress === 100
              ? <h3>Upload Complete!</h3>
              : <h3>Uploading artwork</h3>}
            <span>
              {fileUploadProgress === 100
                ? <>Thanks for your submission, we&apos;ll review your artwork and get back to you via the email you provided.</>
                : `${fileUploadProgress}%`}
            </span>
            {fileUploadProgress === 100
              ? <div
                  className="submit ok-button"
                  onClick={() => onClickOkSuccess()}
              >
                OK
              </div>
              : <></>}
          </div>
          <div className="popup-background" />
        </div>
      ) : (<></>)}

      <div className="landing-header">
        <div className="ball" />
      </div>

      <div className="landing-form-container">

        <div className="landing-form">
          <div className="submission-form">
            <div className="input-title">
              Artist Name
            </div>
            <input
              onChange={(e) => updateArtistNameInput(e)}
              spellCheck={false}
              value={artistNameInput}
              placeholder="Enter your name"
            />
            {artistNameInvalid === 1
              ? <span className="helper-text">Please enter a valid name.</span>
              : <></>}

            <div className="input-title">
              Email
            </div>
            <input
              onChange={(e) => updateEmailInput(e)}
              spellCheck={false}
              value={emailInput}
              placeholder="name@example.com"
            />
            {emailInvalid === 1
              ? <span className="helper-text">Please enter a valid email.</span>
              : <></>}

            <div className="input-title">
              Social Media URL
            </div>
            <input
              onChange={(e) => updateSocialInput(e)}
              spellCheck={false}
              value={socialInput}
              placeholder="twitter.com/handle"
            />
            {socialInvalid === 1
              ? <span className="helper-text">Please enter a valid social media URL.</span>
              : <></>}

            <div className="tick-container">
              <div className="tick" onClick={() => toggleTerms()}>
                {agreeToTermsAndConditions ? <div className="aggree-tick" /> : <></>}
              </div>
              <div className="tick-about">
                I have read &amp; agree to the
                <br />
                <span
                  className="link-text"
                  onClick={() => toggleTermsAndConditionsPopup()}
                >
                  Terms &amp; Conditions
                </span>
                .
              </div>
            </div>
            {termsAndConditionsInvalid === 1
              ? <span className="helper-text">You need to agree to the terms &amp; conditions.</span>
              : <></>}

            <div className="submit-button-container">
              <label className="submit attach-artwork-button" htmlFor="select-file">
                {uploadAssetOriginalFileName.length === 0
                  ? <>
                    <span className="button-cta">ATTACH ARTWORK</span>
                    <span className="file-rules">w2048 x h2048, 2mb max, PNG or JPG</span>
                  </>
                  : uploadAssetOriginalFileName.length > 20 ? '... ' + uploadAssetOriginalFileName.slice(-20) : uploadAssetOriginalFileName}
              </label>
              <input
                id="select-file"
                type="file"
                style={{ display: 'none' }}
                accept=".png, .jpg, .jpeg"
                onChange={onSelectFile}
              />
              <div
                className="submit submit-button"
                onClick={() => onClickSubmit()}
              >
                SUBMIT
              </div>
            </div>
            {uploadAssetFileSize >= 2000000
              ? <span className="helper-text">File size must be under 2MB.</span>
              : <></>}
            {!assetFile && submitWasClicked
              ? <span className="helper-text">Please attach your artwork.</span>
              : <></>}
          </div>
        </div>
        <div className="landing-copy">
          <h2>
            Be On
            <br />
            The Ball.
          </h2>
          <span>
            <b>Be a part of sporting history.</b>
            <br />
            <br />
            Have your artwork showcased on AO's Genesis NFT collection:
            {' '}
            <a href="https://ao.artball.io" target="_blank" rel="noopener noreferrer">The AO Art Ball</a>
            .
            <br />
            <br />
            Submit your artwork for the chance to be involved in a first for the
            Australian Open and help shape the future of sports culture and art.
          </span>
        </div>
      </div>
    </div>
  );
};

LandingComponent.defaultProps = defaultProps;

export default LandingComponent;
